import { CDN_ASSET_URL, IS_CHROME_EXTENSION } from "@src/env";

/**
 * Gets the full URL for an asset, using CDN if available.
 *
 * @example
 * ```tsx
 * <img src={getAssetUrl("/images/doctor-patient-2.jpg")} alt="Doctor and Patient" />
 * ```
 */
export function getAssetUrl(assetPath: string): string {
  if (!assetPath) {
    return assetPath;
  }

  const normalizedPath = assetPath.startsWith("/")
    ? assetPath
    : `/${assetPath}`;

  if (
    IS_CHROME_EXTENSION &&
    typeof chrome !== "undefined" &&
    chrome.runtime?.getURL
  ) {
    return chrome.runtime.getURL(normalizedPath);
  }

  if (CDN_ASSET_URL) {
    const normalizedCdn = CDN_ASSET_URL.endsWith("/")
      ? CDN_ASSET_URL
      : `${CDN_ASSET_URL}/`;

    return `${normalizedCdn}public${normalizedPath}`;
  }

  return assetPath;
}
